export const SignInQa = {
    SIGN_IN_FORM: 'sign-in-form',
    INPUT_LOGIN: 'sign-in-login',
    INPUT_PASSWORD: 'sign-in-password',
};
